<div *ngIf="agent.scoreBreakdown" class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
  <!-- Score Breakdown -->
  <div class="bg-gray-50 rounded-xl p-4 border border-gray-200">
    <h4 class="text-xs font-bold uppercase tracking-wider text-gray-600 mb-3 flex items-center gap-2">
      <i class="fas fa-calculator text-green-600"></i> Score Breakdown
    </h4>
    <div class="space-y-2 text-xs">
      <div class="flex justify-between">
        <span class="text-gray-500">Vouchers converted ({{ agent.voucherCollectionsCount }})</span>
        <span class="font-bold text-indigo-700">+{{ agent.scoreBreakdown.voucherPoints }}</span>
      </div>
      <div class="flex justify-between">
        <span class="text-gray-500">Sales value (₹{{ agent.totalGrossValue | number:'1.0-0' }})</span>
        <span class="font-bold text-amber-700">+{{ agent.scoreBreakdown.salesPoints }}</span>
      </div>
      <div class="flex justify-between">
        <span class="text-gray-500">Leaves ({{ agent.leaveDays }} days, {{ agent.unplannedLeaveDays }} unplanned)</span>
        <span class="font-bold text-red-600">−{{ agent.scoreBreakdown.leavePenaltyPoints }}</span>
      </div>
      <div class="flex justify-between border-t border-gray-200 pt-2">
        <span class="font-semibold text-gray-700">Total score</span>
        <span class="font-bold text-gray-900">{{ agent.compositeScore }}</span>
      </div>
    </div>
  </div>

  <!-- Zone Sales Ranking -->
  <div class="bg-gray-50 rounded-xl p-4 border border-gray-200">
    <h4 class="text-xs font-bold uppercase tracking-wider text-gray-600 mb-3 flex items-center gap-2">
      <i class="fas fa-map-marked-alt text-teal-600"></i> Zone Sales Rank
    </h4>
    <div *ngFor="let zone of agent.zoneRankings ?? []" class="flex items-center justify-between text-xs py-1.5 border-b border-gray-100 last:border-0">
      <div>
        <span class="font-medium text-gray-900">{{ zone.zoneName }}</span>
        <span class="text-[10px] text-gray-500 block">₹{{ zone.salesValue | number:'1.0-0' }} · {{ zone.collectionsCount }} pickups</span>
      </div>
      <span *ngIf="zone.rank !== null" class="px-2 py-0.5 rounded-full font-bold"
        [class.bg-amber-100]="zone.rank === 1" [class.text-amber-800]="zone.rank === 1"
        [class.bg-gray-100]="zone.rank !== 1" [class.text-gray-700]="zone.rank !== 1">
        #{{ zone.rank }} of {{ zone.rankedAgentsCount }}
      </span>
      <span *ngIf="zone.rank === null" class="text-gray-400">No sales</span>
    </div>
    <div *ngIf="!agent.zoneRankings?.length" class="text-xs text-gray-400">No zones assigned.</div>
  </div>
</div>
